import { Component, OnInit, HostBinding } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { MFormation } from '@argalis-apps/models';
import { FormationService } from '../../services/formation/formation.service';
import { CatalogConfigService } from '../../services/catalog-config/catalog-config.service';

@Component({
  selector: 'ags-fiche-formation',
  templateUrl: './fiche-formation.component.html',
  styleUrls: ['./fiche-formation.component.scss']
})
export class FicheFormationComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  private queryParamFirstInit = false;
  private identifier: string = null;
  public modalite: number = null;
  public postal: string = null;
  public infoFormation: MFormation.IFormInfo;
  constructor(
    private route: ActivatedRoute,
    private formationService: FormationService,
    catalogConfigService: CatalogConfigService
  ) {
    this.themeFlag = `${this.themeFlag || ''} ${catalogConfigService.themingClassName}`;
  }

  ngOnInit() {
    this.route.queryParams.subscribe((query: Params) => {
      this.queryParamFirstInit = true;
      this.modalite = parseInt(`${query['moda']}`, 10) || null;
      this.postal = query['postal'];
      this.modalite = query['moda'] || 1;
      if (this.identifier !== null) {
        this.initFormInfo();
      }

      /*
       * - le choix de law modalite doit peut être défini dans l'URL (query param)
       * - choix automatique de la "première" modalité si elle n'est pas définie dans l'URL
       *
       * - le code postal de "proximité" géographie peut être défini dans l'URL (query param)
       * - le code postal de "proximité" peut être importé depuis le compte client s'il n'est pas défini dans l'URL
       */
    });
    this.route.params.subscribe((params: Params) => {
      this.identifier = params['identifier'];
      if (this.queryParamFirstInit) {
        this.initFormInfo();
      }
      // - identifier dans l'URL: comment différencier les produits des parcours ?
    });
  }

  initFormInfo() {
    this.formationService.get(parseInt(`${this.identifier}`, 10), this.modalite, false, this.postal).subscribe(
      formation => {
        this.infoFormation = formation;
      },
      () => {
        //TODO
      }
    );
  }
}
